import './S_CollapseSection.scss';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/joy';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { MouseEvent, ReactElement, ReactNode, useState } from 'react';
import { ExpandLessIcon } from '../../static/icons/ExpandLessIcon';
import { ExpandMoreIcon } from '../../static/icons/ExpandMoreIcon';

interface IProps {
  title: string;
  subtitle: string;
  children?: ReactNode;
  showInfoIcon?: boolean;
  infoIconTooltip?: string;
  onInfoIconClick?: (e: MouseEvent) => void;
}

export const S_CollapseSection = observer((props: IProps): ReactElement => {
  const { title, subtitle, children, showInfoIcon, infoIconTooltip, onInfoIconClick } = props;

  const [isOpen, setIsOpen] = useState(true);
  const toggle = (): void => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div
        className='s-collapse-section-header'
        onClick={toggle}
      >
        <div className='section-title-container'>
          <div className='section-title'>{title}</div>
          <div className='section-subtitle'>{subtitle}</div>
          {showInfoIcon && (
            <div
              className='section-info-icon'
              onClick={onInfoIconClick}
            >
              <FontAwesomeIcon
                icon={faInfoCircle}
                title={infoIconTooltip}
              />
            </div>
          )}
        </div>
        <IconButton>{isOpen ? <ExpandLessIcon className='expand-icon' /> : <ExpandMoreIcon className='expand-icon' />}</IconButton>
      </div>
      <div className={classNames('s-collapse-section-body', { 'is-open': isOpen })}>{children}</div>
    </div>
  );
});
